import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { StatusIndicatorRoot } from "./root.js";
import { StatusIndicatorValue } from "./value.js";
//#region src/ui/status-indicator/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Root: () => StatusIndicatorRoot,
	Value: () => StatusIndicatorValue
});
//#endregion
export { StatusIndicatorRoot as Root, StatusIndicatorValue as Value, index_parts_exports };

//# sourceMappingURL=index.parts.js.map